export function validateEmail(email: string) {
  const pattern =
    /^(([^<>()\\.,;:@\s"]+(\.[^<>()\\.,;:@\s"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]+))$/;
  return pattern.test(email);
}
